/**
 * Extract organization and env-id from multi-part subdomain string.
 * Example input: "system-industriafox-pr-vs-prod-1.public.production.lb1"
 *                "wa-ces-industriafox-pr-vs-hom-1.public.homologation.lb1"
 * Output: { organization: "industriafox", envId: "pr-vs-prod-1" }
 * Output: { organization: "industriafox", envId: "pr-vs-hom-1" }
 */
function extractOrgAndEnvIdFromSubdomain(subdomain: string): {
  organization: string
  envId: string
} {
  // Only look at the portion before the first dot
  const [main] = subdomain.split('.')
  // Find index of -pr-vs- or other env prefixes
  const envMatch = main.match(/-([a-zA-Z]+-vs-[a-zA-Z]+-\d+)$/)
  if (!envMatch) return { organization: '', envId: '' }
  const envId = envMatch[1]
  // Get organization: segment immediately before envId (between last and second last hyphen)
  const orgMatch = main.match(/-(\w+)-[a-zA-Z]+-vs-[a-zA-Z]+-\d+$/)
  if (!orgMatch) return { organization: '', envId }
  return { organization: orgMatch[1], envId }
}

export default extractOrgAndEnvIdFromSubdomain
